package article.spring

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.LocalTextStyle
import androidx.compose.material.Slider
import androidx.compose.material.SliderDefaults
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.lerp
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp


const val SPRING_STIFFNESS = "ffc6978eb73fdab8fbdc8dd86a51f7d9fe34c2f91592b55854127d83d64f95e6"

@Composable
fun SpringStiffness() {

    SpringGrid {
        val density = LocalDensity.current
        var width by remember { mutableStateOf(10) }
        val widthDp by remember {
            derivedStateOf {
                with(density) {
                    width.toDp()
                }
            }
        }

        Column(
            Modifier
                .onSizeChanged { width = it.width }
                .fillMaxSize()
        ) {

            var compressed by remember { mutableStateOf(false) }
            var stiffness by remember { mutableStateOf(1500f) }


            val offset by animateDpAsState(
                targetValue = if (compressed) widthDp * .75f else 32.dp,
                animationSpec = spring(
                    dampingRatio = Spring.DampingRatioNoBouncy,
                    stiffness = stiffness,
                )
            )

            Row(
                Modifier.fillMaxWidth().weight(1f),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Box(
                    Modifier.fillMaxSize(),
                ) {

                    Box(
                        Modifier
                            .align(Alignment.Center)
                            .offset {
                                IntOffset((width / 2), 0)
                            }
                            .fillMaxHeight()
                            .requiredWidth((widthDp * 2) - (offset * 2) - 50.dp)
                    ) {
                        SpringCoil(50, SpringCoilOrientation.Horizontal)
                    }

                    Orb(
                        modifier = Modifier
                            .align(Alignment.CenterStart)
                            .offset {
                                IntOffset(offset.roundToPx(), 0)
                            }
                            .onGloballyPositioned {

                            }
                            .size(50.dp).background(Color.White, CircleShape),
                        glow = false,
                    )


                }
            }

            Column(
                Modifier.padding(horizontal = 32.dp).fillMaxWidth().weight(1f),

                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally,

                ) {


                Row(
                    Modifier.fillMaxWidth(),
                ) {

                    Text(
                        "stiffness: ",
                        modifier = Modifier.weight(1.4f),
                        textAlign = TextAlign.End
                    )

                    Text(
                        " ${stiffness.toInt()}",
                        modifier = Modifier.weight(1f),
                        style = LocalTextStyle.current.copy(
                            fontFeatureSettings = "tnum"
                        ),
                        textAlign = TextAlign.Start
                    )

                }


                Slider(
                    stiffness,
                    onValueChange = {
                        stiffness = it
                    },
                    valueRange = 0f..10_000f,
                    colors = SliderDefaults.colors(
                        thumbColor = lerp(springPink, springYellow, stiffness / 10_000f),
                        activeTrackColor = lerp(springPink, springYellow, stiffness / 10_000f),
                    )
                )

                SpringButton(
                    onClick = {
                        compressed = !compressed
                    }
                ) {
                    Text("Animate", color = Color.Black)
                }

            }

        }

    }
}